// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2XYvD","productName":"Table_productName__26rKQ"};